import httpClient from "@utils/httpClient";

/**
 * Get today's attendance for logged-in employee
 */
export const getTodayAttendance = async () => {
  try {
    const response = await httpClient.get('/employee/attendance/today');

    return {
      success: response.success,
      data: response.data || null,
      error: response.error
    };
  } catch (error) {
    console.error('getTodayAttendance error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

/**
 * Punch in for the day
 */
export const punchIn = async () => {
  try {
    const response = await httpClient.post('/employee/attendance/punch-in');

    return {
      success: response.success,
      data: response.data || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('punchIn error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to punch in' }
    };
  }
};

/**
 * Punch out for the day
 */
export const punchOut = async () => {
  try {
    const response = await httpClient.post('/employee/attendance/punch-out');

    return {
      success: response.success,
      data: response.data || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('punchOut error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to punch out' }
    };
  }
};

/**
 * Update daily remarks/notes
 */
export const updateDailyRemarks = async (remarks) => {
  try {
    const response = await httpClient.put('/employee/attendance/remarks', { remarks });

    return {
      success: response.success,
      data: response.data || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('updateDailyRemarks error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to update daily remarks' }
    };
  }
};

/**
 * Get attendance history with pagination
 */
export const getAttendanceHistory = async (page = 1, limit = 30) => {
  try {
    const response = await httpClient.get(`/employee/attendance/history?page=${page}&limit=${limit}`);

    return {
      success: response.success,
      data: response.data || [],
      pagination: response.pagination || {},
      error: response.error
    };
  } catch (error) {
    console.error('getAttendanceHistory error:', error);
    return {
      success: false,
      data: [],
      pagination: {},
      error: { message: error.message }
    };
  }
};

/**
 * Get attendance summary statistics
 */
export const getAttendanceSummary = async (startDate, endDate) => {
  try {
    let url = '/employee/attendance/summary';
    const params = [];

    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data || {},
      error: response.error
    };
  } catch (error) {
    console.error('getAttendanceSummary error:', error);
    return {
      success: false,
      data: {},
      error: { message: error.message }
    };
  }
};

/**
 * Get current week attendance stats (Monday to Friday)
 */
export const getCurrentWeekStats = async () => {
  try {
    const response = await httpClient.get('/employee/attendance/week-stats');

    return {
      success: response.success,
      data: response.data || {},
      error: response.error
    };
  } catch (error) {
    console.error('getCurrentWeekStats error:', error);
    return {
      success: false,
      data: {},
      error: { message: error.message }
    };
  }
};

/**
 * Get team attendance for reporting manager
 */
export const getTeamAttendance = async (date) => {
  try {
    let url = '/employee/attendance/team';
    if (date) {
      url += `?date=${date}`;
    }

    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getTeamAttendance error:', error);
    return {
      success: false,
      data: [],
      error: { message: error.message }
    };
  }
};

/**
 * Get user's daily update flag status
 */
export const getUserDailyUpdateFlag = async () => {
  try {
    const response = await httpClient.get('/employee/attendance/daily-update-flag');

    return {
      success: response.success,
      data: response.data || null,
      error: response.error
    };
  } catch (error) {
    console.error('getUserDailyUpdateFlag error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};